var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.getBranch()
    ? _c("div", [
        _c(
          "div",
          {
            staticClass:
              "w-100pct h-60px cl-white f-s-18px f-w-bold pd-5px dp-flex al-it-center jtf-ct-center",
            style: "background-color: " + _vm.mainColor + ";"
          },
          [
            _c("span", { staticClass: "mg-l-10px" }, [
              _vm._v(_vm._s(_vm.storeName) + " | " + _vm._s(_vm.branchName))
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "column is-6 is-offset-3 is-paddingless" }, [
          _c(
            "div",
            { staticClass: "columns is-centered is-marginless h-60px" },
            [
              _c("div", { staticClass: "column" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.search,
                      expression: "search"
                    }
                  ],
                  staticClass: "input-data f-left pd-6px",
                  attrs: {
                    placeholder: "กรุณาใส่ชื่อสินค้าที่ต้องการค้นหา",
                    type: "search"
                  },
                  domProps: { value: _vm.search },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.search = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "f-left search pd-6px cs-pointer",
                    style: "background-color: " + _vm.mainColor + ";",
                    on: {
                      click: function($event) {
                        _vm.searchData()
                      }
                    }
                  },
                  [
                    _c("svg-filler", {
                      attrs: {
                        path: "/static/svg/search.svg",
                        fill: "#ffffff",
                        width: "20px",
                        height: "20px"
                      }
                    })
                  ],
                  1
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "list-item" }, [
            _c(
              "div",
              [
                _c("ListProduct", {
                  attrs: { products: _vm.products, searchKey: _vm.searchKey },
                  on: {
                    "update:products": function($event) {
                      _vm.products = $event
                    },
                    "update:searchKey": function($event) {
                      _vm.searchKey = $event
                    }
                  }
                })
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "w-100pct h-60px cl-white f-s-18px f-w-bold",
            style: "background-color: " + _vm.mainColor + ";"
          },
          [
            _c("div", { staticClass: "columns is-marginless is-paddingless" }, [
              _c(
                "div",
                {
                  staticClass:
                    "column is-paddingless is-6 is-offset-3 dp-flex jtf-ct-space-between"
                },
                [
                  _c(
                    "div",
                    { staticClass: "pd-16px" },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "UserInfo" }, exact: "" } },
                        [
                          _c("svg-filler", {
                            attrs: {
                              path: "/static/svg/user.svg",
                              fill: "#ffffff",
                              width: "24px",
                              height: "24px"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "pd-6px" },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "ScanToSearch" }, exact: "" } },
                        [
                          _c("svg-filler", {
                            attrs: {
                              path: "/static/svg/QR_icon.svg",
                              fill: "#ffffff",
                              width: "48px",
                              height: "48px"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "pd-r-20px" },
                    [
                      _vm.amount === 0
                        ? _c("svg-filler", {
                            staticClass: "mg-t-16px",
                            attrs: {
                              path: "/static/svg/basket.svg",
                              fill: "#ffffff",
                              width: "24px",
                              height: "24px"
                            }
                          })
                        : _c(
                            "router-link",
                            { attrs: { to: { name: "Cart" }, exact: "" } },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "tag cartItemCount is-danger pst-absolute mg-l-15px mg-t-8px"
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.amount) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("svg-filler", {
                                staticClass: "mg-t-16px",
                                attrs: {
                                  path: "/static/svg/basket.svg",
                                  fill: "#ffffff",
                                  width: "24px",
                                  height: "24px"
                                }
                              })
                            ],
                            1
                          )
                    ],
                    1
                  )
                ]
              )
            ])
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3dd2e005", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dd2e005","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/Home.vue
// module id = 403
// module chunks = 1